import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Toast = (message, toastType, loading, closeTime = 2000, id = 100) => {
  const isToastActive = toast.isActive(id);
  if (isToastActive) {
    toast.update(id, {
      render: message,
      type: toastType,
      isLoading: loading,
      autoClose: closeTime,
      //   transition: "Bounce",
      position: toast.TOP_CENTER,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  } else {
    toast[`${toastType}`](message, {
      toastId: id,
      autoClose: closeTime,
      position: toast.TOP_CENTER,
      //   transition: "Bounce",
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};
export const SuccessToast = (message) => {
  return toast.success(message, {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    // transition: "Bounce",
  });
};

// Error toast component
export const ErrorToast = (message) => {
  return toast.error(message, {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    // transition: "Bounce",
  });
};

export default Toast;
